import styles from './MatchList.module.css';


const MatchItem = ({ match, isFavorite, onToggleFavorite }) => {
  const formatTime = (isoString) => {
    if (!isoString) return 'B/D';
    try {
      const date = new Date(isoString);
      return date.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Warsaw' });
    } catch {
      return 'Błąd';
    }
  };

  // Helper to render team with logo
  const renderTeam = (name, logo) => (
    <div className={styles.matchTeams}>
      {logo && <img src={logo} alt={name} className={styles.teamLogo} loading="lazy" />}
      <span>{name}</span>
    </div>
  );

  return (
    <div className={`${styles.matchItem} ${isFavorite ? styles.favoriteMatch : ''}`}>
      <div className={styles.matchMeta}>
        <span className={styles.matchTime}>{match.start ? formatTime(match.start) : 'LIVE'}</span>
        <div className={styles.channelListContainer}>
          {match.channels?.map(channel => (
            <span key={channel} className={styles.matchChannel}>{channel}</span>
          ))}
        </div>
        <button
          className={`${styles.favoriteBtn} ${isFavorite ? styles.isFavorite : ''}`}
          onClick={(e) => { e.stopPropagation(); onToggleFavorite(match.home || match.title); }}
          title={isFavorite ? "Usuń z ulubionych" : "Dodaj do ulubionych"}
        >
          {isFavorite ? '★' : '☆'}
        </button>
      </div>

      {match.league && <div className={styles.matchLeague}>{match.league}</div>}

      <div className={styles.matchTitle}>
        {match.home && match.away ? (
          <div className={styles.teamsContainer}>
            {renderTeam(match.home, match.homeLogo)}
            <span className={styles.teamsSeparator}>-</span>
            {renderTeam(match.away, match.awayLogo)}
          </div>
        ) : (
          match.title
        )}
      </div>

      <div className={styles.matchActions}>
        <a
          href={`/api/match/${match._id}.ics`}
          download
          className={styles.calendarButton}
          title="Dodaj do kalendarza"
        >
          📅
        </a>
      </div>
    </div>
  );
};

export default MatchItem;
